import { HTMLProps, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

/**
 * Kbd component for displaying keyboard keys with consistent styling.
 * Sizes itself relative to the parent's font-size using em units.
 *
 * `disabled` is read here rather than spread onto the element: `<kbd>` cannot carry the attribute,
 * so React dropped it and a key the screen does not respond to rendered identically to one it does.
 * The keyboard help marks the axis a screen ignores that way, and said nothing.
 */
export const Kbd = ({ className, children, disabled, ...props }: HTMLProps<HTMLElement>): ReactNode => {
  return (
    <kbd
      data-disabled={disabled ? true : undefined}
      aria-disabled={disabled ? true : undefined}
      className={twMerge(
        'inline-block rounded-xl border-4 border-gray-300 border-r-gray-400 border-b-gray-400',
        'bg-gray-50 px-2 py-0.5 leading-snug font-normal text-gray-800',
        'shadow',
        disabled && 'border-gray-400 border-r-gray-500 border-b-gray-500 bg-gray-300 text-gray-500 shadow-none',
        className,
      )}
      {...props}>
      {children}
    </kbd>
  );
};
